<template>
    <div class='tep-koef-group'>
        <ai-form-check-box
            :meta="props.meta"
            :callbacks='{ userDataChanged: changeCheckbox }'
        ></ai-form-check-box>
        <div class='btn-wrap'>
            <dx-button
                style="width: 60px"
                :disabled='!currentValue'
                @click="openNsi"
                text='Кис'
            ></dx-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tep-av-system-choice',
};
</script>
<script setup>
import AiFormCheckBox from '@/components/card-component/ai-form-check-box.vue';
import { DxButton } from 'devextreme-vue';
import { dxUiNotify } from '@/utils/dx-helper';
import { onMounted, ref } from 'vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null })
    }
});

const currentValue = ref({});

onMounted(() => {
    currentValue.value = props.serverData[props.meta.fieldNameText];
})

const changeCheckbox = () => {
    currentValue.value = !currentValue.value;
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
}

const openNsi = () => {
    console.log('tip:', props.meta.fieldNameKis);
    dxUiNotify('Функция в разработке', 'info', 3000);
}
</script>

<style scoped>
.tep-koef-group {
    display: flex;
    align-items: center;
}
.tep-koef-group :deep(.dx-field) {
    padding: 0;
}
.btn-wrap {
    margin-left: 10px;
}
</style>
